import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import SequenceEditor from './SequenceEditor.vue';
import Dashboard from './Dashboard.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/remarketing'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({ name: 'remarketing_list', params: to.params }),
        },
        {
          path: 'list',
          name: 'remarketing_list',
          component: Index,
          meta: {
            featureFlag: FEATURE_FLAGS.REMARKETING_SEQUENCES,
            permissions: ['administrator'],
          },
        },
        {
          path: 'new',
          name: 'remarketing_new',
          component: SequenceEditor,
          meta: {
            featureFlag: FEATURE_FLAGS.REMARKETING_SEQUENCES,
            permissions: ['administrator'],
          },
        },
        {
          path: ':id/edit',
          name: 'remarketing_edit',
          component: SequenceEditor,
          meta: {
            featureFlag: FEATURE_FLAGS.REMARKETING_SEQUENCES,
            permissions: ['administrator'],
          },
        },
        {
          path: 'dashboard',
          name: 'remarketing_dashboard',
          component: Dashboard,
          meta: {
            featureFlag: FEATURE_FLAGS.REMARKETING_SEQUENCES,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
